import {
  Table as TableComponent,
  TBody,
  TCell,
  TCellText,
  TCellTextTooltip,
  TCellTextTooltipContent,
  TCellUser,
  TCellSpace,
  TCellChannel,
  THead,
  THeadMulti,
  THeadCell,
  THeadCellSortable,
  THeadCellSortableTooltip,
  THeadCellTooltipExpand,
  THeadCellText,
  THeadCellTooltip,
  TRow,
  TRowFillable,
  TRowExpandableInside,
  TRowExpandableOutside,
  TFooter,
} from './components';

export const Table = Object.assign(TableComponent, {
  TBody,
  THead,
  THeadMulti,
  THeadCell,
  THeadCellText,
  THeadCellSortable,
  THeadCellSortableTooltip,
  THeadCellTooltipExpand,
  THeadCellTooltip,
  TCellTextTooltipContent,
  TRow,
  TRowFillable,
  TRowExpandableInside,
  TRowExpandableOutside,
  TCell,
  TCellUser,
  TCellSpace,
  TCellChannel,
  TCellText,
  TCellTextTooltip,
  TFooter,
});
